var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 auto","width":"100%"}},[_c('Header'),_vm._v(" "),_c('ActivityHead'),_vm._v(" "),_c('ActivitySign'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7696c4ad","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/daoba-match/views/program/ActivitySign.vue
// module id = null
// module chunks = 